var exports = {
  "n8": "VoiceChannelActivityLine.module__line___VE9Iel",
  "Kk": "VoiceChannelActivityLine.module__icon___VE9Iel",
  "UU": "VoiceChannelActivityLine.module__name___VE9Iel",
  "Fk": "VoiceChannelActivityLine.module__players___VE9Iel",
};

module.exports = exports;
